import useSWR from 'swr';
import { fetcher } from '@/shared/api/fetcher';

const useWelcomeBonus = () => {
  const { data, error, isLoading } = useSWR(`/welcomeBonus`, fetcher, {
    dedupingInterval: 5000, // Не повторять запросы чаще 5 сек
    errorRetryCount: 1, // Максимум 1 повтор при ошибке
    shouldRetryOnError: false, // Отключить повтор при 500 ошибках
  });

  return {
    data,
    error,
    isLoading,
  };
};

export { useWelcomeBonus };
